import { ListItemButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import useAccessControl from "../hook/useAccessControl";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";

type Props = {
  item: any;
};

const SlidebarItemWithOutCollapse = ({ item }: Props) => {
  const location = useLocation();
  const { permissions }: any = useAccessControl();
  const role = Cookies.get("role-express-tire") || '';
  const [isActive, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname.startsWith(item?.path)) {
      setActive(true);
    }
    else {
      setActive(false);
    }
  }, [location, item]);

  return (
    item.sidebarProps && item.path && (role.toLowerCase() === "admin" || permissions[item.section || ''] || item.section === "dashboard") ? (
      <ListItemButton
        component={Link}
        to={item.path}
        className="w-full flex p-[10px] items-center gap-2.5"
        sx={{
          "&: hover": {
            backgroundColor: "#EA8616",
            color: "#ffffff"
          },
          backgroundColor: isActive ? "#EA8616" : "unset",
          color: isActive ? "#ffffff" : "#000000",
          padding: "10px",
          borderRight: "unset"
        }}
      >

        <span className={`material-symbols-outlined text-inherit text-[25px] font-extralight`}>
          {item.sidebarProps.icon && item.sidebarProps.icon}
        </span>
        <span className={`text-inherit text-[13px] font-medium tracking-wide whitespace-normal`}>
          {item.sidebarProps.displayText}
        </span>
      </ListItemButton>
    ) : null
  );
};

export default SlidebarItemWithOutCollapse;